import React from 'react';
export function Footer() {
  return <footer className="bg-carbon-950 border-t border-carbon-800 py-16 px-4 text-center" data-id="element-59">
      <div className="max-w-4xl mx-auto" data-id="element-60">
        <div className="inline-flex items-center gap-3 mb-6" data-id="element-61">
          <span className="w-1.5 h-1.5 bg-electric rounded-full" data-id="element-62" />
          <span className="font-mono text-sm text-carbon-300 uppercase tracking-widest" data-id="element-63">
            Método Hybrid 360™
          </span>
        </div>
        <p className="text-carbon-500 font-sans text-sm mb-12" data-id="element-64">
          Porque entrenar con criterio no debería costar años de improvisación.
        </p>
        <div className="flex flex-wrap justify-center gap-6 sm:gap-10 text-xs font-mono uppercase tracking-widest text-carbon-600" data-id="element-65">
          <a href="#" className="hover:text-carbon-300 transition-colors" data-id="element-66">
            Términos y condiciones
          </a>
          <a href="#" className="hover:text-carbon-300 transition-colors" data-id="element-67">
            Política de privacidad
          </a>
          <a href="#" className="hover:text-carbon-300 transition-colors" data-id="element-68">
            Contacto
          </a>
        </div>
      </div>
    </footer>;
}